"use client";

var _excluded = ["value", "defaultValue", "onChange", "form", "name", "by", "disabled", "onClose", "__demoMode", "multiple", "immediate", "virtual", "nullable"],
  _excluded2 = ["id", "onChange", "displayValue", "disabled", "autoFocus", "type"],
  _excluded3 = ["id", "disabled", "autoFocus"],
  _excluded4 = ["id", "hold", "anchor", "portal", "modal", "transition"],
  _excluded5 = ["id", "value", "disabled", "order"];
var _It;
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { useFocusRing as Ee } from "@react-aria/focus";
import { useHover as Se } from "@react-aria/interactions";
import { useVirtualizer as Ne } from "@tanstack/react-virtual";
import F, { Fragment as Ie, createContext as me, createRef as ke, useCallback as ce, useContext as fe, useMemo as W, useReducer as Ue, useRef as Z, useState as He } from "react";
import { flushSync as ee } from "react-dom";
import { useActivePress as Ge } from '../../hooks/use-active-press.js';
import { useByComparator as ze } from '../../hooks/use-by-comparator.js';
import { useControllable as Ke } from '../../hooks/use-controllable.js';
import { useDefaultValue as We } from '../../hooks/use-default-value.js';
import { useDisposables as je } from '../../hooks/use-disposables.js';
import { useElementSize as Pe } from '../../hooks/use-element-size.js';
import { useEvent as c } from '../../hooks/use-event.js';
import { useId as se } from '../../hooks/use-id.js';
import { useInertOthers as $e } from '../../hooks/use-inert-others.js';
import { useIsoMorphicEffect as X } from '../../hooks/use-iso-morphic-effect.js';
import { useLatestValue as Xe } from '../../hooks/use-latest-value.js';
import { useOnDisappear as Je } from '../../hooks/use-on-disappear.js';
import { useOutsideClick as qe } from '../../hooks/use-outside-click.js';
import { useOwnerDocument as Ae } from '../../hooks/use-owner.js';
import { useRefocusableInput as Re } from '../../hooks/use-refocusable-input.js';
import { useResolveButtonType as Ye } from '../../hooks/use-resolve-button-type.js';
import { useScrollLock as Qe } from '../../hooks/use-scroll-lock.js';
import { useSyncRefs as de } from '../../hooks/use-sync-refs.js';
import { useTrackedPointer as Ze } from '../../hooks/use-tracked-pointer.js';
import { transitionDataAttributes as et, useTransition as tt } from '../../hooks/use-transition.js';
import { useTreeWalker as ot } from '../../hooks/use-tree-walker.js';
import { useWatch as _e } from '../../hooks/use-watch.js';
import { useDisabled as nt } from '../../internal/disabled.js';
import { FloatingProvider as it, useFloatingPanel as rt, useFloatingPanelProps as lt, useFloatingReference as at, useResolvedAnchor as ut } from '../../internal/floating.js';
import { FormFields as pt } from '../../internal/form-fields.js';
import { Frozen as st, useFrozenData as he } from '../../internal/frozen.js';
import { useProvidedId as dt } from '../../internal/id.js';
import { OpenClosedProvider as bt, State as be, useOpenClosed as mt } from '../../internal/open-closed.js';
import { history as Me } from '../../utils/active-element-history.js';
import { isDisabledReactIssue7711 as ct } from '../../utils/bugs.js';
import { Focus as I, calculateActiveIndex as De } from '../../utils/calculate-active-index.js';
import { disposables as Fe } from '../../utils/disposables.js';
import { sortByDomNode as ft } from '../../utils/focus-management.js';
import { match as te } from '../../utils/match.js';
import { isMobile as Tt } from '../../utils/platform.js';
import { RenderFeatures as Ve, forwardRefWithAs as ne, mergeProps as Te, render as ie } from '../../utils/render.js';
import { useDescribedBy as xt } from '../description/description.js';
import { Keys as B } from '../keyboard.js';
import { Label as gt, useLabelledBy as xe, useLabels as vt } from '../label/label.js';
import { MouseButton as Le } from '../mouse.js';
import { Portal as yt } from '../portal/portal.js';
var Ot = function (e) {
    return e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e;
  }(Ot || {}),
  Ct = function (e) {
    return e[e.Single = 0] = "Single", e[e.Multi = 1] = "Multi", e;
  }(Ct || {}),
  Et = function (o) {
    return o[o.Pointer = 0] = "Pointer", o[o.Focus = 1] = "Focus", o[o.Other = 2] = "Other", o;
  }(Et || {}),
  St = function (l) {
    return l[l.OpenCombobox = 0] = "OpenCombobox", l[l.CloseCombobox = 1] = "CloseCombobox", l[l.GoToOption = 2] = "GoToOption", l[l.SetTyping = 3] = "SetTyping", l[l.RegisterOption = 4] = "RegisterOption", l[l.UnregisterOption = 5] = "UnregisterOption", l[l.SetActivationTrigger = 6] = "SetActivationTrigger", l[l.UpdateVirtualConfiguration = 7] = "UpdateVirtualConfiguration", l[l.SetInputElement = 8] = "SetInputElement", l[l.SetButtonElement = 9] = "SetButtonElement", l[l.SetOptionsElement = 10] = "SetOptionsElement", l;
  }(St || {});
function ge(t) {
  var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (e) {
    return e;
  };
  var e = t.activeOptionIndex !== null ? t.options[t.activeOptionIndex] : null,
    o = n(t.options.slice()),
    f = o.length > 0 && o[0].dataRef.current.order !== null ? o.sort(function (m, d) {
      return m.dataRef.current.order - d.dataRef.current.order;
    }) : ft(o, function (m) {
      return m.dataRef.current.domRef.current;
    }),
    b = e ? f.indexOf(e) : null;
  return b === -1 && (b = null), {
    options: f,
    activeOptionIndex: b
  };
}
var It = (_It = {}, _defineProperty(_It, 1, function _(t) {
    var n;
    return (n = t.dataRef.current) != null && n.disabled || t.comboboxState === 1 ? t : _objectSpread(_objectSpread({}, t), {}, {
      activeOptionIndex: null,
      comboboxState: 1,
      isTyping: !1,
      activationTrigger: 2,
      __demoMode: !1
    });
  }), _defineProperty(_It, 0, function _(t) {
    var n, e;
    if ((n = t.dataRef.current) != null && n.disabled || t.comboboxState === 0) return t;
    if ((e = t.dataRef.current) != null && e.value) {
      var o = t.dataRef.current.calculateIndex(t.dataRef.current.value);
      if (o !== -1) return _objectSpread(_objectSpread({}, t), {}, {
        activeOptionIndex: o,
        comboboxState: 0,
        __demoMode: !1
      });
    }
    return _objectSpread(_objectSpread({}, t), {}, {
      comboboxState: 0,
      __demoMode: !1
    });
  }), _defineProperty(_It, 3, function _(t, n) {
    return t.isTyping === n.isTyping ? t : _objectSpread(_objectSpread({}, t), {}, {
      isTyping: n.isTyping
    });
  }), _defineProperty(_It, 2, function _(t, n) {
    var b, m, d, T;
    if ((b = t.dataRef.current) != null && b.disabled || t.optionsElement && !((m = t.dataRef.current) != null && m.optionsPropsRef.current.static) && t.comboboxState === 1) return t;
    if (t.virtual) {
      var _t$virtual = t.virtual,
        r = _t$virtual.options,
        i = _t$virtual.disabled,
        l = n.focus === I.Specific ? n.idx : De(n, {
          resolveItems: function resolveItems() {
            return r;
          },
          resolveActiveIndex: function resolveActiveIndex() {
            var A, s;
            return (s = (A = t.activeOptionIndex) != null ? A : r.findIndex(function (V) {
              return !i(V);
            })) != null ? s : null;
          },
          resolveDisabled: i,
          resolveId: function resolveId() {
            throw new Error("Function not implemented.");
          }
        }),
        S = (d = n.trigger) != null ? d : 2;
      return t.activeOptionIndex === l && t.activationTrigger === S ? t : _objectSpread(_objectSpread({}, t), {}, {
        activeOptionIndex: l,
        activationTrigger: S,
        isTyping: !1,
        __demoMode: !1
      });
    }
    var e = ge(t);
    if (e.activeOptionIndex === null) {
      var _r = e.options.findIndex(function (i) {
        return !i.dataRef.current.disabled;
      });
      _r !== -1 && (e.activeOptionIndex = _r);
    }
    var o = n.focus === I.Specific ? n.idx : De(n, {
        resolveItems: function resolveItems() {
          return e.options;
        },
        resolveActiveIndex: function resolveActiveIndex() {
          return e.activeOptionIndex;
        },
        resolveId: function resolveId(r) {
          return r.id;
        },
        resolveDisabled: function resolveDisabled(r) {
          return r.dataRef.current.disabled;
        }
      }),
      f = (T = n.trigger) != null ? T : 2;
    return t.activeOptionIndex === o && t.activationTrigger === f ? t : _objectSpread(_objectSpread(_objectSpread({}, t), e), {}, {
      isTyping: !1,
      activeOptionIndex: o,
      activationTrigger: f,
      __demoMode: !1
    });
  }), _defineProperty(_It, 4, function _(t, n) {
    var b, m, d;
    if ((b = t.dataRef.current) != null && b.virtual) return _objectSpread(_objectSpread({}, t), {}, {
      options: [].concat(_toConsumableArray(t.options), [n.payload])
    });
    var e = n.payload,
      o = ge(t, function (T) {
        return T.push(e), T;
      });
    t.activeOptionIndex === null && (m = t.dataRef.current) != null && m.isSelected(n.payload.dataRef.current.value) && (o.activeOptionIndex = o.options.indexOf(e));
    var f = _objectSpread(_objectSpread(_objectSpread({}, t), o), {}, {
      activationTrigger: 2
    });
    return (d = t.dataRef.current) != null && d.__demoMode && t.dataRef.current.value === void 0 && (f.activeOptionIndex = 0), f;
  }), _defineProperty(_It, 5, function _(t, n) {
    var o;
    if ((o = t.dataRef.current) != null && o.virtual) return _objectSpread(_objectSpread({}, t), {}, {
      options: t.options.filter(function (f) {
        return f.id !== n.id;
      })
    });
    var e = ge(t, function (f) {
      var b = f.findIndex(function (m) {
        return m.id === n.id;
      });
      return b !== -1 && f.splice(b, 1), f;
    });
    return _objectSpread(_objectSpread(_objectSpread({}, t), e), {}, {
      activationTrigger: 2
    });
  }), _defineProperty(_It, 6, function _(t, n) {
    return t.activationTrigger === n.trigger ? t : _objectSpread(_objectSpread({}, t), {}, {
      activationTrigger: n.trigger
    });
  }), _defineProperty(_It, 7, function _(t, n) {
    var o, f;
    if (t.virtual === null) return _objectSpread(_objectSpread({}, t), {}, {
      virtual: {
        options: n.options,
        disabled: (o = n.disabled) != null ? o : function () {
          return !1;
        }
      }
    });
    if (t.virtual.options === n.options && t.virtual.disabled === n.disabled) return t;
    var e = t.activeOptionIndex;
    if (t.activeOptionIndex !== null) {
      var b = n.options.indexOf(t.virtual.options[t.activeOptionIndex]);
      b !== -1 ? e = b : e = null;
    }
    return _objectSpread(_objectSpread({}, t), {}, {
      activeOptionIndex: e,
      virtual: {
        options: n.options,
        disabled: (f = n.disabled) != null ? f : function () {
          return !1;
        }
      }
    });
  }), _defineProperty(_It, 8, function _(t, n) {
    return t.inputElement === n.element ? t : _objectSpread(_objectSpread({}, t), {}, {
      inputElement: n.element
    });
  }), _defineProperty(_It, 9, function _(t, n) {
    return t.buttonElement === n.element ? t : _objectSpread(_objectSpread({}, t), {}, {
      buttonElement: n.element
    });
  }), _defineProperty(_It, 10, function _(t, n) {
    return t.optionsElement === n.element ? t : _objectSpread(_objectSpread({}, t), {}, {
      optionsElement: n.element
    });
  }), _It),
  ve = /*#__PURE__*/me(null);
ve.displayName = "ComboboxActionsContext";
function re(t) {
  var n = fe(ve);
  if (n === null) {
    var e = new Error("<".concat(t, " /> is missing a parent <Combobox /> component."));
    throw Error.captureStackTrace && Error.captureStackTrace(e, re), e;
  }
  return n;
}
var Be = /*#__PURE__*/me(null);
function Pt(t) {
  var n = oe("VirtualProvider"),
    e = n.virtual.options,
    _W = W(function () {
      var r = n.optionsElement;
      if (!r) return [0, 0];
      var i = window.getComputedStyle(r);
      return [parseFloat(i.paddingBlockStart || i.paddingTop), parseFloat(i.paddingBlockEnd || i.paddingBottom)];
    }, [n.optionsElement]),
    _W2 = _slicedToArray(_W, 2),
    o = _W2[0],
    f = _W2[1],
    b = Ne({
      enabled: e.length !== 0,
      scrollPaddingStart: o,
      scrollPaddingEnd: f,
      count: e.length,
      estimateSize: function estimateSize() {
        return 40;
      },
      getScrollElement: function getScrollElement() {
        return n.optionsElement;
      },
      overscan: 12
    }),
    _He = He(0),
    _He2 = _slicedToArray(_He, 2),
    m = _He2[0],
    d = _He2[1];
  X(function () {
    d(function (r) {
      return r + 1;
    });
  }, [e]);
  var T = b.getVirtualItems();
  return T.length === 0 ? null : /*#__PURE__*/F.createElement(Be.Provider, {
    value: b
  }, /*#__PURE__*/F.createElement("div", {
    style: {
      position: "relative",
      width: "100%",
      height: "".concat(b.getTotalSize(), "px")
    },
    ref: function ref(r) {
      if (r) {
        if (typeof process != "undefined" && process.env.JEST_WORKER_ID !== void 0 || n.activationTrigger === 0) return;
        n.activeOptionIndex !== null && e.length > n.activeOptionIndex && b.scrollToIndex(n.activeOptionIndex);
      }
    }
  }, T.map(function (r) {
    var i;
    return /*#__PURE__*/F.createElement(Ie, {
      key: r.key
    }, /*#__PURE__*/F.cloneElement((i = t.children) == null ? void 0 : i.call(t, _objectSpread(_objectSpread({}, t.slot), {}, {
      option: e[r.index]
    })), {
      key: "".concat(m, "-").concat(r.key),
      "data-index": r.index,
      "aria-setsize": e.length,
      "aria-posinset": r.index + 1,
      style: {
        position: "absolute",
        top: 0,
        left: 0,
        transform: "translateY(".concat(r.start, "px)"),
        overflowAnchor: "none"
      }
    }));
  })));
}
var le = /*#__PURE__*/me(null);
le.displayName = "ComboboxDataContext";
function oe(t) {
  var n = fe(le);
  if (n === null) {
    var e = new Error("<".concat(t, " /> is missing a parent <Combobox /> component."));
    throw Error.captureStackTrace && Error.captureStackTrace(e, oe), e;
  }
  return n;
}
function At(t, n) {
  return te(n.type, It, t, n);
}
var Rt = Ie;
function _t(t, n) {
  var _te3;
  var ye, Oe;
  var e = nt(),
    o = t.value,
    f = t.defaultValue,
    b = t.onChange,
    m = t.form,
    d = t.name,
    T = t.by,
    _t$disabled = t.disabled,
    r = _t$disabled === void 0 ? e || !1 : _t$disabled,
    i = t.onClose,
    _t$__demoMode = t.__demoMode,
    l = _t$__demoMode === void 0 ? !1 : _t$__demoMode,
    _t$multiple = t.multiple,
    S = _t$multiple === void 0 ? !1 : _t$multiple,
    _t$immediate = t.immediate,
    A = _t$immediate === void 0 ? !1 : _t$immediate,
    _t$virtual2 = t.virtual,
    s = _t$virtual2 === void 0 ? null : _t$virtual2,
    V = t.nullable,
    N = _objectWithoutProperties(t, _excluded),
    _ = We(f),
    _Ke = Ke(o, b, _),
    _Ke2 = _slicedToArray(_Ke, 2),
    _Ke2$ = _Ke2[0],
    C = _Ke2$ === void 0 ? S ? [] : void 0 : _Ke2$,
    x = _Ke2[1],
    _Ue = Ue(At, {
      dataRef: /*#__PURE__*/ke(),
      comboboxState: l ? 0 : 1,
      isTyping: !1,
      options: [],
      virtual: s ? {
        options: s.options,
        disabled: (ye = s.disabled) != null ? ye : function () {
          return !1;
        }
      } : null,
      activeOptionIndex: null,
      activationTrigger: 2,
      inputElement: null,
      buttonElement: null,
      optionsElement: null,
      __demoMode: l
    }),
    _Ue2 = _slicedToArray(_Ue, 2),
    P = _Ue2[0],
    v = _Ue2[1],
    M = Z(!1),
    y = Z({
      static: !1,
      hold: !1
    }),
    D = ze(T),
    j = c(function (p) {
      return s ? T === null ? s.options.indexOf(p) : s.options.findIndex(function (g) {
        return D(g, p);
      }) : P.options.findIndex(function (g) {
        return D(g.dataRef.current.value, p);
      });
    }),
    q = ce(function (p) {
      var _te;
      return te(u.mode, (_te = {}, _defineProperty(_te, 1, function _() {
        return C.some(function (g) {
          return D(g, p);
        });
      }), _defineProperty(_te, 0, function _() {
        return D(C, p);
      }), _te));
    }, [C]),
    H = c(function (p) {
      return P.activeOptionIndex === j(p);
    }),
    u = W(function () {
      return _objectSpread(_objectSpread({}, P), {}, {
        immediate: A,
        optionsPropsRef: y,
        value: C,
        defaultValue: _,
        disabled: r,
        mode: S ? 1 : 0,
        virtual: s ? P.virtual : null,
        get activeOptionIndex() {
          if (M.current && P.activeOptionIndex === null && (s ? s.options.length > 0 : P.options.length > 0)) {
            if (s) {
              var g = s.options.findIndex(function (z) {
                var pe, Ce;
                return !((Ce = (pe = s.disabled) == null ? void 0 : pe.call(s, z)) != null && Ce);
              });
              if (g !== -1) return g;
            }
            var p = P.options.findIndex(function (g) {
              return !g.dataRef.current.disabled;
            });
            if (p !== -1) return p;
          }
          return P.activeOptionIndex;
        },
        calculateIndex: j,
        compare: D,
        isSelected: q,
        isActive: H
      });
    }, [C, _, r, S, l, P, s]);
  X(function () {
    var p;
    s && v({
      type: 7,
      options: s.options,
      disabled: (p = s.disabled) != null ? p : null
    });
  }, [s, s == null ? void 0 : s.options, s == null ? void 0 : s.disabled]), X(function () {
    P.dataRef.current = u;
  }, [u]);
  var G = u.comboboxState === 0;
  qe(G, [u.buttonElement, u.inputElement, u.optionsElement], function () {
    return L.closeCombobox();
  });
  var K = W(function () {
      var p, g, z;
      return {
        open: u.comboboxState === 0,
        disabled: r,
        activeIndex: u.activeOptionIndex,
        activeOption: u.activeOptionIndex === null ? null : u.virtual ? u.virtual.options[(p = u.activeOptionIndex) != null ? p : 0] : (z = (g = u.options[u.activeOptionIndex]) == null ? void 0 : g.dataRef.current.value) != null ? z : null,
        value: C
      };
    }, [u, r, C]),
    O = c(function () {
      if (u.activeOptionIndex !== null) {
        if (L.setIsTyping(!1), u.virtual) Q(u.virtual.options[u.activeOptionIndex]);else {
          var p = u.options[u.activeOptionIndex].dataRef;
          Q(p.current.value);
        }
        L.goToOption(I.Specific, u.activeOptionIndex);
      }
    }),
    k = c(function () {
      v({
        type: 0
      }), M.current = !0;
    }),
    Y = c(function () {
      v({
        type: 1
      }), M.current = !1, i == null || i();
    }),
    J = c(function (p) {
      v({
        type: 3,
        isTyping: p
      });
    }),
    h = c(function (p, g, z) {
      return M.current = !1, p === I.Specific ? v({
        type: 2,
        focus: I.Specific,
        idx: g,
        trigger: z
      }) : v({
        type: 2,
        focus: p,
        trigger: z
      });
    }),
    ae = c(function (p, g) {
      return v({
        type: 4,
        payload: {
          id: p,
          dataRef: g
        }
      }), function () {
        u.isActive(g.current.value) && (M.current = !0), v({
          type: 5,
          id: p
        });
      };
    }),
    Q = c(function (p) {
      var _te2;
      return te(u.mode, (_te2 = {}, _defineProperty(_te2, 0, function _() {
        return x == null ? void 0 : x(p);
      }), _defineProperty(_te2, 1, function _() {
        var g = u.value.slice(),
          z = g.findIndex(function (pe) {
            return D(pe, p);
          });
        return z === -1 ? g.push(p) : g.splice(z, 1), x == null ? void 0 : x(g);
      }), _te2));
    }),
    ue = c(function (p) {
      v({
        type: 6,
        trigger: p
      });
    }),
    a = c(function (p) {
      v({
        type: 8,
        element: p
      });
    }),
    U = c(function (p) {
      v({
        type: 9,
        element: p
      });
    }),
    R = c(function (p) {
      v({
        type: 10,
        element: p
      });
    }),
    L = W(function () {
      return {
        onChange: Q,
        registerOption: ae,
        goToOption: h,
        setIsTyping: J,
        closeCombobox: Y,
        openCombobox: k,
        setActivationTrigger: ue,
        selectActiveOption: O,
        setInputElement: a,
        setButtonElement: U,
        setOptionsElement: R
      };
    }, []),
    _vt = vt(),
    _vt2 = _slicedToArray(_vt, 2),
    E = _vt2[0],
    w = _vt2[1],
    $ = n === null ? {} : {
      ref: n
    },
    we = ce(function () {
      if (_ !== void 0) return x == null ? void 0 : x(_);
    }, [x, _]);
  return /*#__PURE__*/F.createElement(w, {
    value: E,
    props: {
      htmlFor: (Oe = u.inputElement) == null ? void 0 : Oe.id
    },
    slot: {
      open: u.comboboxState === 0,
      disabled: r
    }
  }, /*#__PURE__*/F.createElement(it, null, /*#__PURE__*/F.createElement(ve.Provider, {
    value: L
  }, /*#__PURE__*/F.createElement(le.Provider, {
    value: u
  }, /*#__PURE__*/F.createElement(bt, {
    value: te(u.comboboxState, (_te3 = {}, _defineProperty(_te3, 0, be.Open), _defineProperty(_te3, 1, be.Closed), _te3))
  }, d != null && /*#__PURE__*/F.createElement(pt, {
    disabled: r,
    data: C != null ? _defineProperty({}, d, C) : {},
    form: m,
    onReset: we
  }), ie({
    ourProps: $,
    theirProps: N,
    slot: K,
    defaultTag: Rt,
    name: "Combobox"
  }))))));
}
var ht = "input";
function Mt(t, n) {
  var J, h, ae, Q, ue;
  var e = oe("Combobox.Input"),
    o = re("Combobox.Input"),
    f = se(),
    b = dt(),
    _t$id = t.id,
    m = _t$id === void 0 ? b || "headlessui-combobox-input-".concat(f) : _t$id,
    d = t.onChange,
    T = t.displayValue,
    _t$disabled2 = t.disabled,
    r = _t$disabled2 === void 0 ? e.disabled || !1 : _t$disabled2,
    _t$autoFocus = t.autoFocus,
    i = _t$autoFocus === void 0 ? !1 : _t$autoFocus,
    _t$type = t.type,
    l = _t$type === void 0 ? "text" : _t$type,
    S = _objectWithoutProperties(t, _excluded2),
    A = Z(null),
    s = de(A, n, at(), o.setInputElement),
    V = Ae(e.inputElement),
    N = je(),
    _ = c(function () {
      o.onChange(null), e.optionsElement && (e.optionsElement.scrollTop = 0), o.goToOption(I.Nothing);
    }),
    C = W(function () {
      var a;
      return typeof T == "function" && e.value !== void 0 ? (a = T(e.value)) != null ? a : "" : typeof e.value == "string" ? e.value : "";
    }, [e.value, T]);
  _e(function (_ref2, _ref3) {
    var _ref4 = _slicedToArray(_ref2, 2),
      a = _ref4[0],
      U = _ref4[1];
    var _ref5 = _slicedToArray(_ref3, 2),
      R = _ref5[0],
      L = _ref5[1];
    if (e.isTyping) return;
    var E = A.current;
    E && ((L === 0 && U === 1 || a !== R) && (E.value = a), requestAnimationFrame(function () {
      if (e.isTyping || !E || (V == null ? void 0 : V.activeElement) !== E) return;
      var w = E.selectionStart,
        $ = E.selectionEnd;
      Math.abs(($ != null ? $ : 0) - (w != null ? w : 0)) === 0 && w === 0 && E.setSelectionRange(E.value.length, E.value.length);
    }));
  }, [C, e.comboboxState, V, e.isTyping]), _e(function (_ref6, _ref7) {
    var _ref8 = _slicedToArray(_ref6, 1),
      a = _ref8[0];
    var _ref9 = _slicedToArray(_ref7, 1),
      U = _ref9[0];
    if (a === 0 && U === 1) {
      if (e.isTyping) return;
      var R = A.current;
      if (!R) return;
      var L = R.value,
        E = R.selectionStart,
        w = R.selectionEnd,
        $ = R.selectionDirection;
      R.value = "", R.value = L, $ !== null ? R.setSelectionRange(E, w, $) : R.setSelectionRange(E, w);
    }
  }, [e.comboboxState]);
  var x = Z(!1),
    P = c(function () {
      x.current = !0;
    }),
    v = c(function () {
      N.nextFrame(function () {
        x.current = !1;
      });
    }),
    M = c(function (a) {
      var _te4, _te5;
      switch (o.setIsTyping(!0), a.key) {
        case B.Enter:
          if (e.comboboxState !== 0 || x.current) return;
          if (a.preventDefault(), a.stopPropagation(), e.activeOptionIndex === null) {
            o.closeCombobox();
            return;
          }
          o.selectActiveOption(), e.mode === 0 && o.closeCombobox();
          break;
        case B.ArrowDown:
          return a.preventDefault(), a.stopPropagation(), te(e.comboboxState, (_te4 = {}, _defineProperty(_te4, 0, function _() {
            return o.goToOption(I.Next);
          }), _defineProperty(_te4, 1, function _() {
            return o.openCombobox();
          }), _te4));
        case B.ArrowUp:
          return a.preventDefault(), a.stopPropagation(), te(e.comboboxState, (_te5 = {}, _defineProperty(_te5, 0, function _() {
            return o.goToOption(I.Previous);
          }), _defineProperty(_te5, 1, function _() {
            ee(function () {
              return o.openCombobox();
            }), e.value || o.goToOption(I.Last);
          }), _te5));
        case B.Home:
          if (a.shiftKey) break;
          return a.preventDefault(), a.stopPropagation(), o.goToOption(I.First);
        case B.PageUp:
          return a.preventDefault(), a.stopPropagation(), o.goToOption(I.First);
        case B.End:
          if (a.shiftKey) break;
          return a.preventDefault(), a.stopPropagation(), o.goToOption(I.Last);
        case B.PageDown:
          return a.preventDefault(), a.stopPropagation(), o.goToOption(I.Last);
        case B.Escape:
          return e.comboboxState !== 0 ? void 0 : (a.preventDefault(), e.optionsElement && !e.optionsPropsRef.current.static && a.stopPropagation(), e.mode === 0 && e.value === null && _(), o.closeCombobox());
        case B.Tab:
          if (e.comboboxState !== 0) return;
          e.mode === 0 && e.activationTrigger !== 1 && o.selectActiveOption(), o.closeCombobox();
          break;
      }
    }),
    y = c(function (a) {
      d == null || d(a), e.mode === 0 && a.target.value === "" && _(), o.openCombobox();
    }),
    D = c(function (a) {
      var R, L, E;
      var U = (R = a.relatedTarget) != null ? R : Me.find(function (w) {
        return w !== a.currentTarget;
      });
      if (!((L = e.optionsElement) != null && L.contains(U)) && !((E = e.buttonElement) != null && E.contains(U)) && e.comboboxState === 0) return a.preventDefault(), e.mode === 0 && e.value === null && _(), o.closeCombobox();
    }),
    j = c(function (a) {
      var R, L, E;
      var U = (R = a.relatedTarget) != null ? R : Me.find(function (w) {
        return w !== a.currentTarget;
      });
      (L = e.buttonElement) != null && L.contains(U) || (E = e.optionsElement) != null && E.contains(U) || e.disabled || e.immediate && e.comboboxState !== 0 && N.microTask(function () {
        ee(function () {
          return o.openCombobox();
        }), o.setActivationTrigger(1);
      });
    }),
    q = xe(),
    H = xt(),
    _Ee = Ee({
      autoFocus: i
    }),
    u = _Ee.isFocused,
    G = _Ee.focusProps,
    _Se = Se({
      isDisabled: r
    }),
    K = _Se.isHovered,
    O = _Se.hoverProps,
    k = W(function () {
      return {
        open: e.comboboxState === 0,
        disabled: r,
        hover: K,
        focus: u,
        autofocus: i
      };
    }, [e, K, u, i, r]),
    Y = Te({
      ref: s,
      id: m,
      role: "combobox",
      type: l,
      "aria-controls": (J = e.optionsElement) == null ? void 0 : J.id,
      "aria-expanded": e.comboboxState === 0,
      "aria-activedescendant": e.activeOptionIndex === null ? void 0 : e.virtual ? (h = e.options.find(function (a) {
        return !a.dataRef.current.disabled && e.compare(a.dataRef.current.value, e.virtual.options[e.activeOptionIndex]);
      })) == null ? void 0 : h.id : (ae = e.options[e.activeOptionIndex]) == null ? void 0 : ae.id,
      "aria-labelledby": q,
      "aria-describedby": H,
      "aria-autocomplete": "list",
      defaultValue: (ue = (Q = t.defaultValue) != null ? Q : e.defaultValue !== void 0 ? T == null ? void 0 : T(e.defaultValue) : null) != null ? ue : e.defaultValue,
      disabled: r || void 0,
      autoFocus: i,
      onCompositionStart: P,
      onCompositionEnd: v,
      onKeyDown: M,
      onChange: y,
      onFocus: j,
      onBlur: D
    }, G, O);
  return ie({
    ourProps: Y,
    theirProps: S,
    slot: k,
    defaultTag: ht,
    name: "Combobox.Input"
  });
}
var Dt = "button";
function Ft(t, n) {
  var M;
  var e = oe("Combobox.Button"),
    o = re("Combobox.Button"),
    f = de(n, o.setButtonElement),
    b = se(),
    _t$id2 = t.id,
    m = _t$id2 === void 0 ? "headlessui-combobox-button-".concat(b) : _t$id2,
    _t$disabled3 = t.disabled,
    d = _t$disabled3 === void 0 ? e.disabled || !1 : _t$disabled3,
    _t$autoFocus2 = t.autoFocus,
    T = _t$autoFocus2 === void 0 ? !1 : _t$autoFocus2,
    r = _objectWithoutProperties(t, _excluded3),
    i = Re(e.inputElement),
    l = c(function (y) {
      switch (y.key) {
        case B.Space:
        case B.Enter:
          y.preventDefault(), y.stopPropagation(), e.comboboxState === 1 && ee(function () {
            return o.openCombobox();
          }), i();
          return;
        case B.ArrowDown:
          y.preventDefault(), y.stopPropagation(), e.comboboxState === 1 && (ee(function () {
            return o.openCombobox();
          }), e.value || o.goToOption(I.First)), i();
          return;
        case B.ArrowUp:
          y.preventDefault(), y.stopPropagation(), e.comboboxState === 1 && (ee(function () {
            return o.openCombobox();
          }), e.value || o.goToOption(I.Last)), i();
          return;
        case B.Escape:
          if (e.comboboxState !== 0) return;
          y.preventDefault(), e.optionsElement && !e.optionsPropsRef.current.static && y.stopPropagation(), ee(function () {
            return o.closeCombobox();
          }), i();
          return;
        default:
          return;
      }
    }),
    S = c(function (y) {
      y.preventDefault(), !ct(y.currentTarget) && (y.button === Le.Left && (e.comboboxState === 0 ? o.closeCombobox() : o.openCombobox()), i());
    }),
    A = xe([m]),
    _Ee2 = Ee({
      autoFocus: T
    }),
    s = _Ee2.isFocusVisible,
    V = _Ee2.focusProps,
    _Se2 = Se({
      isDisabled: d
    }),
    N = _Se2.isHovered,
    _ = _Se2.hoverProps,
    _Ge = Ge({
      disabled: d
    }),
    C = _Ge.pressed,
    x = _Ge.pressProps,
    P = W(function () {
      return {
        open: e.comboboxState === 0,
        active: C || e.comboboxState === 0,
        disabled: d,
        value: e.value,
        hover: N,
        focus: s
      };
    }, [e, N, s, C, d]),
    v = Te({
      ref: f,
      id: m,
      type: Ye(t, e.buttonElement),
      tabIndex: -1,
      "aria-haspopup": "listbox",
      "aria-controls": (M = e.optionsElement) == null ? void 0 : M.id,
      "aria-expanded": e.comboboxState === 0,
      "aria-labelledby": A,
      disabled: d || void 0,
      autoFocus: T,
      onMouseDown: S,
      onKeyDown: l
    }, V, _, x);
  return ie({
    ourProps: v,
    theirProps: r,
    slot: P,
    defaultTag: Dt,
    name: "Combobox.Button"
  });
}
var Vt = "div",
  Lt = Ve.RenderStrategy | Ve.Static;
function Bt(t, n) {
  var k, Y, J;
  var e = se(),
    _t$id3 = t.id,
    o = _t$id3 === void 0 ? "headlessui-combobox-options-".concat(e) : _t$id3,
    _t$hold = t.hold,
    f = _t$hold === void 0 ? !1 : _t$hold,
    b = t.anchor,
    _t$portal = t.portal,
    m = _t$portal === void 0 ? !1 : _t$portal,
    _t$modal = t.modal,
    d = _t$modal === void 0 ? !0 : _t$modal,
    _t$transition = t.transition,
    T = _t$transition === void 0 ? !1 : _t$transition,
    r = _objectWithoutProperties(t, _excluded4),
    i = oe("Combobox.Options"),
    l = re("Combobox.Options"),
    S = ut(b);
  S && (m = !0);
  var _rt = rt(S),
    _rt2 = _slicedToArray(_rt, 2),
    A = _rt2[0],
    s = _rt2[1],
    V = lt(),
    N = de(n, S ? A : null, l.setOptionsElement),
    _ = Ae(i.optionsElement),
    C = mt(),
    _tt = tt(T, i.optionsElement, C !== null ? (C & be.Open) === be.Open : i.comboboxState === 0),
    _tt2 = _slicedToArray(_tt, 2),
    x = _tt2[0],
    P = _tt2[1];
  Je(x, i.inputElement, l.closeCombobox);
  var v = i.__demoMode ? !1 : d && i.comboboxState === 0;
  Qe(v, _);
  var M = i.__demoMode ? !1 : d && i.comboboxState === 0;
  $e(M, {
    allowed: ce(function () {
      return [i.inputElement, i.buttonElement, i.optionsElement];
    }, [i.inputElement, i.buttonElement, i.optionsElement])
  }), X(function () {
    var h;
    i.optionsPropsRef.current.static = (h = t.static) != null ? h : !1;
  }, [i.optionsPropsRef, t.static]), X(function () {
    i.optionsPropsRef.current.hold = f;
  }, [i.optionsPropsRef, f]), ot(i.comboboxState === 0, {
    container: i.optionsElement,
    accept: function accept(h) {
      return h.getAttribute("role") === "option" ? NodeFilter.FILTER_REJECT : h.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
    },
    walk: function walk(h) {
      h.setAttribute("role", "none");
    }
  });
  var y = xe([(k = i.buttonElement) == null ? void 0 : k.id]),
    D = W(function () {
      return {
        open: i.comboboxState === 0,
        option: void 0
      };
    }, [i.comboboxState]),
    j = c(function () {
      l.setActivationTrigger(0);
    }),
    q = c(function (h) {
      h.preventDefault(), l.setActivationTrigger(0);
    }),
    H = Te(S ? V() : {}, _objectSpread({
      "aria-labelledby": y,
      role: "listbox",
      "aria-multiselectable": i.mode === 1 ? !0 : void 0,
      id: o,
      ref: N,
      style: _objectSpread(_objectSpread(_objectSpread({}, r.style), s), {}, {
        "--input-width": Pe(i.inputElement, !0).width,
        "--button-width": Pe(i.buttonElement, !0).width
      }),
      onWheel: i.activationTrigger === 0 ? void 0 : j,
      onMouseDown: q
    }, et(P))),
    u = x && i.comboboxState === 1,
    G = he(u, (Y = i.virtual) == null ? void 0 : Y.options),
    K = he(u, i.value),
    O = c(function (h) {
      return i.compare(K, h);
    });
  if (i.virtual) {
    if (G === void 0) throw new Error("Missing `options` in virtual mode");
    Object.assign(r, {
      children: /*#__PURE__*/F.createElement(le.Provider, {
        value: G !== i.virtual.options ? _objectSpread(_objectSpread({}, i), {}, {
          virtual: _objectSpread(_objectSpread({}, i.virtual), {}, {
            options: G
          })
        }) : i
      }, /*#__PURE__*/F.createElement(Pt, {
        slot: D
      }, r.children))
    });
  }
  return /*#__PURE__*/F.createElement(yt, {
    enabled: m ? t.static || x : !1
  }, /*#__PURE__*/F.createElement(le.Provider, {
    value: i.mode === 1 ? i : _objectSpread(_objectSpread({}, i), {}, {
      isSelected: O
    })
  }, ie({
    ourProps: H,
    theirProps: _objectSpread(_objectSpread({}, r), {}, {
      children: /*#__PURE__*/F.createElement(st, {
        freeze: u
      }, typeof r.children == "function" ? (J = r.children) == null ? void 0 : J.call(r, D) : r.children)
    }),
    slot: D,
    defaultTag: Vt,
    features: Lt,
    visible: x,
    name: "Combobox.Options"
  })));
}
var wt = "div";
function Nt(t, n) {
  var H, u, G, K;
  var e = oe("Combobox.Option"),
    o = re("Combobox.Option"),
    f = se(),
    _t$id4 = t.id,
    b = _t$id4 === void 0 ? "headlessui-combobox-option-".concat(f) : _t$id4,
    m = t.value,
    _t$disabled4 = t.disabled,
    d = _t$disabled4 === void 0 ? (G = (u = (H = e.virtual) == null ? void 0 : H.disabled) == null ? void 0 : u.call(H, m)) != null ? G : !1 : _t$disabled4,
    _t$order = t.order,
    T = _t$order === void 0 ? null : _t$order,
    r = _objectWithoutProperties(t, _excluded5),
    i = Re(e.inputElement),
    l = e.virtual ? e.activeOptionIndex === e.calculateIndex(m) : e.activeOptionIndex === null ? !1 : ((K = e.options[e.activeOptionIndex]) == null ? void 0 : K.id) === b,
    S = e.isSelected(m),
    A = Z(null),
    s = Xe({
      disabled: d,
      value: m,
      domRef: A,
      order: T
    }),
    V = fe(Be),
    N = de(n, A, V ? V.measureElement : null),
    _ = c(function () {
      o.setIsTyping(!1), o.onChange(m);
    });
  X(function () {
    return o.registerOption(b, s);
  }, [s, b]);
  var C = Z(!(e.virtual || e.__demoMode));
  X(function () {
    if (!e.virtual && !e.__demoMode) return Fe().requestAnimationFrame(function () {
      C.current = !0;
    });
  }, [e.virtual, e.__demoMode]), X(function () {
    if (C.current && e.comboboxState === 0 && l && e.activationTrigger !== 0) return Fe().requestAnimationFrame(function () {
      var O, k;
      (k = (O = A.current) == null ? void 0 : O.scrollIntoView) == null || k.call(O, {
        block: "nearest"
      });
    });
  }, [A, l, e.comboboxState, e.activationTrigger, e.activeOptionIndex]);
  var x = c(function (O) {
      O.preventDefault(), O.button === Le.Left && (d || (_(), Tt() || requestAnimationFrame(function () {
        return i();
      }), e.mode === 0 && o.closeCombobox()));
    }),
    P = c(function () {
      if (d) return o.goToOption(I.Nothing);
      var O = e.calculateIndex(m);
      o.goToOption(I.Specific, O);
    }),
    v = Ze(),
    M = c(function (O) {
      return v.update(O);
    }),
    y = c(function (O) {
      if (!v.wasMoved(O) || d || l) return;
      var k = e.calculateIndex(m);
      o.goToOption(I.Specific, k, 0);
    }),
    D = c(function (O) {
      v.wasMoved(O) && (d || l && (e.optionsPropsRef.current.hold || o.goToOption(I.Nothing)));
    }),
    j = W(function () {
      return {
        active: l,
        focus: l,
        selected: S,
        disabled: d
      };
    }, [l, S, d]);
  return ie({
    ourProps: {
      id: b,
      ref: N,
      role: "option",
      tabIndex: d === !0 ? void 0 : -1,
      "aria-disabled": d === !0 ? !0 : void 0,
      "aria-selected": S,
      disabled: void 0,
      onMouseDown: x,
      onFocus: P,
      onPointerEnter: M,
      onMouseEnter: M,
      onPointerMove: y,
      onMouseMove: y,
      onPointerLeave: D,
      onMouseLeave: D
    },
    theirProps: r,
    slot: j,
    defaultTag: wt,
    name: "Combobox.Option"
  });
}
var kt = ne(_t),
  Ut = ne(Ft),
  Ht = ne(Mt),
  Gt = gt,
  zt = ne(Bt),
  Kt = ne(Nt),
  ko = Object.assign(kt, {
    Input: Ht,
    Button: Ut,
    Label: Gt,
    Options: zt,
    Option: Kt
  });
export { ko as Combobox, Ut as ComboboxButton, Ht as ComboboxInput, Gt as ComboboxLabel, Kt as ComboboxOption, zt as ComboboxOptions };